import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Components, Utils } from 'versafleet-core';
import ReduxActions from 'reduxActions';
import classNames from 'classnames';
import HeaderNotificationPanel from './panel';

class HeaderNotification extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: 'notifications',
      showDropdown: false,
    };
  }

  UNSAFE_componentWillMount() {
    this.props.dispatch(ReduxActions.notification.loadNewCount());
  }

  _toggleDropdown = (showDropdown) => {
    if (showDropdown && !this.state.showDropdown) {
      this.props.dispatch(ReduxActions.notification.resetNewCount());
    }
    this.setState({ showDropdown });
  }

  _onChangeTab(tab) {
    this.setState({ tab });
  }

  _onClickItem(item, type) {
    switch (type) {
      case 'all':
        Utils.Router.transitionTo('/notifications');
        break;
      case 'notification':
        this.props.onClickNotificationItem(item);
        break;
      case 'failedTask':
        this.props.onClickFailedTaskItem(item);
        break;
      default:
        break;
    }
  }

  render() {
    const buttonClassName = classNames({
      'vf-header-notification__button': true,
      'vf-header-notification__button--new': this.props.newNotifications,
    });

    return (
      <Components.ButtonDropdown
        className={buttonClassName}
        iconClassName="versa-notifications"
        id="vf-notifications-page__job-item"
        showDropdown={this.state.showDropdown}
        toggleDropdown={this._toggleDropdown}
      >
        <HeaderNotificationPanel
          onChangeTab={tab => this._onChangeTab(tab)}
          onClickAll={item => this._onClickItem(item, 'all')}
          onClickFailedTaskItem={item => this._onClickItem(item, 'failedTask')}
          onClickNotificationItem={item => this._onClickItem(item, 'notification')}
          tab={this.state.tab}
        />
      </Components.ButtonDropdown>
    );
  }
}

HeaderNotification.displayName = 'Header Notification';

HeaderNotification.propTypes = {
  dispatch: PropTypes.func.isRequired,
  newNotifications: PropTypes.bool,
  onClickFailedTaskItem: PropTypes.func.isRequired,
  onClickNotificationItem: PropTypes.func.isRequired,
};

HeaderNotification.defaultProps = {
  newNotifications: false,
};

function mapStateToProps(state) {
  const { notification } = state;
  return {
    newNotifications: notification.newNotifications,
  };
}

export default connect(mapStateToProps)(HeaderNotification);
